module.exports = __webpack_public_path__ + "static/swirlorganicmuslin-a576ac7aef0f6d8eef804cdb96f8c92c.jpeg";